const SaveForLaterService = (() => {
    const controllerRoot = '/api/save-for-later';

    const getApiRoute = (path) => `${controllerRoot}/${path || ''}`;

    return {
        get: async (path) => {
            // @ts-ignore
            const response = await fetchClient().get(getApiRoute(path));
            return response;
        },
        create: async (path, request) => {
            // @ts-ignore
            const response = await fetchClient().post(getApiRoute(path), request);
            return response;
        },
        update: async (path, request) => {
            // @ts-ignore
            const response = await fetchClient().put(getApiRoute(path), request);
            return response;
        },
        delete: async (path) => {
            // @ts-ignore
            const response = await fetchClient().delete(getApiRoute(path));
            return response;
        },
        patch: async (path, request) => {
            // @ts-ignore
            const response = await fetchClient().patch(getApiRoute(path, request));
            return response;
        },
    }
})();

export default SaveForLaterService;